/* import __COLOCATED_TEMPLATE__ from './apply-changes-modal.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';
import type { PendingChange, TableColumn } from './types';

interface Args {
  isVisible: boolean;
  pendingChanges: PendingChange[];
  tableColumns: TableColumn[];
  hasIncludedChanges: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirmApply: () => void;
  onToggleOrderChanges: () => void;
  onToggleGroupChange: (groupId: string | number) => void;
  onToggleSeatChange: (changeId: string) => void;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
  Blocks: {};
}

const ScimApplyChangesModal = templateOnlyComponent<Signature>();
export default ScimApplyChangesModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::Scim::ApplyChangesModal': typeof ScimApplyChangesModal;
    'new-settings/workspace/teammates/scim/apply-changes-modal': typeof ScimApplyChangesModal;
  }
}
